import { Tier } from 'services/api/tier/types';

const mockBase: Omit<Tier, 'tierList'> = {
  userInfo: {
    memberNumber: '183673976',
    memberSince: '03/01/2024 10:05:39',
    miles: '0',
    dateUpgradeLimit: '04/01/2050',
    tierDateInfo: 'Acumule milhas qualificáveis e conquiste a categoria Essencial',
    showUpgrade: true,
    upgradeInfo: {
      nextTier: 'Essencial',
      milesUpgrade: '1',
      milesMaintenance: '0',
      totalMilesClub: '4100000',
    },
  },
  tips: {
    cardList: [
      {
        title: 'Voe GOL',
        description:
          'Trechos comprados ou resgatados com milhas na Smiles para voar GOL acumulam trechos qualificáveis que te ajudam a subir de categoria.',
        actionTarget: 'buscar-voos',
      },
    ],
  },
};

const mockVoebizDataResponse: Tier = {
  ...mockBase,
  tierList: [
    {
      name: 'VoeBiz',
      active: 'Y',
      startDate: '03/01/2024 00:00:00',
      endDate: '03/31/2050 00:00:00',
      memberName: 'Company name LTDA',
      miles: '0',
    },
  ],
  userInfo: { ...mockBase.userInfo },
};
const mockEssencialDataResponse: Tier = {
  ...mockBase,
  tierList: [
    {
      name: 'Essencial',
      active: 'Y',
      startDate: '03/01/2024 00:00:00',
      endDate: '03/31/2050 00:00:00',
      memberName: 'Company name LTDA',
      miles: '0',
    },
  ],
  userInfo: { ...mockBase.userInfo },
};
const mockPrimeDataResponse: Tier = {
  ...mockBase,
  tierList: [
    {
      name: 'Prime',
      active: 'Y',
      startDate: '03/01/2024 00:00:00',
      endDate: '03/31/2050 00:00:00',
      memberName: 'Company name LTDA',
      miles: '0',
    },
  ],
  userInfo: { ...mockBase.userInfo },
};
const mockSuperPrimeDataResponse: Tier = {
  ...mockBase,
  tierList: [
    {
      name: 'Super Prime',
      active: 'Y',
      startDate: '03/01/2024 00:00:00',
      endDate: '03/31/2050 00:00:00',
      memberName: 'Company name LTDA',
      miles: '0',
    },
  ],
  userInfo: { ...mockBase.userInfo },
};

const mockExclusiveTierDataResponse: Tier = {
  ...mockBase,
  tierList: [
    {
      name: 'Exclusive',
      active: 'Y',
      startDate: '03/01/2024 00:00:00',
      endDate: '03/31/2050 00:00:00',
      memberName: 'Company name LTDA',
      miles: '0',
    },
  ],
  userInfo: {
    ...mockBase.userInfo,
    upgradeInfo: {
      nextTier: 'Essencial',
      milesUpgrade: '1',
      milesMaintenance: '0',
    },
  },
};

export const tierMocks: { [key: string]: Tier } = {
  voebiz: mockVoebizDataResponse,
  essencial: mockEssencialDataResponse,
  prime: mockPrimeDataResponse,
  superPrime: mockSuperPrimeDataResponse,
  exclusive: mockExclusiveTierDataResponse,
};

export const mockTierDataResponse = tierMocks.voebiz;
